import {
  isFeatureFlagEnabled,
  type FeatureFlag,
  type FeatureFlagState,
  type UseFeatureFlagUtilsResult,
} from '@onesource/components';
import { z } from 'zod';

export const EFeatureFlagKey = z.enum(['SHOW_ADDON_APP', 'SHOW_LOCKED_SPACES', 'SHOW_TEACHER_DIRECTORY']);
export const EFeatureFlagEnum = EFeatureFlagKey.enum;
export type TFeatureFlagKey = z.infer<typeof EFeatureFlagKey>;

export const FEATURE_FLAGS_FOR_UI: FeatureFlag[] = [
  {
    key: EFeatureFlagEnum.SHOW_ADDON_APP,
    label: 'Show Addon App',
    defaultValue: false,
    description: 'Show the Addon app in the apps list',
    disabled: import.meta.env.VITE_ADDON_FRONTEND_URL === undefined,
    disabledReason: 'VITE_ADDON_FRONTEND_URL is not configured',
  },
  {
    key: EFeatureFlagEnum.SHOW_LOCKED_SPACES,
    label: 'Show Locked Spaces',
    defaultValue: false,
    description: 'Show locked/inaccessible spaces on the apps page and navigation',
  },
  {
    key: EFeatureFlagEnum.SHOW_TEACHER_DIRECTORY,
    label: 'Show Teacher Directory',
    defaultValue: false,
    description: "Show the Teacher's Directory tab on the My Account page",
  },
] as const;

export { isFeatureFlagEnabled };
export type { FeatureFlag, FeatureFlagState, UseFeatureFlagUtilsResult };
